import { BlockSchema } from './Block.types';

import { HeroBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const HeroBlockSchema = BlockSchema.extend({
  blockConfig: HeroBlockConfigSchema,
});

export type HeroBlock = z.infer<typeof HeroBlockSchema>;
